import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { apiBaseUrl } from './config'

// Configuration Mock API pour contourner les problèmes de serveur
if (apiBaseUrl === '/mock-api') {
  console.log('🛠️ Mode API simulation activé - Pas de connexion au serveur réel');
  
  // Intercepteur pour simuler les réponses API
  axios.interceptors.request.use(
    config => {
      if (config.url.startsWith('/mock-api')) {
        // Simuler un délai de réseau
        return new Promise(resolve => {
          setTimeout(() => {
            // Retourner des données fictives basées sur l'URL
            if (config.url.includes('/verify/user')) {
              return resolve({
                ...config,
                adapter: () => {
                  return Promise.resolve({
                    data: {
                      data: {
                        token: 'mock-token-12345',
                        name: 'User Test',
                        email: 'user@test.com',
                        avatar: 'https://ui-avatars.com/api/?name=User&background=random'
                      }
                    },
                    status: 200,
                    statusText: 'OK',
                    headers: {},
                    config: config
                  });
                }
              });
            }
            
            if (config.url.includes('/get/stats')) {
              return resolve({
                ...config,
                adapter: () => {
                  return Promise.resolve({
                    data: {
                      message: "Statistiques récupérées avec succès.",
                      stats: {
                        chatbotCount: 3,
                        chatbotActive: 2,
                        userCount: 150,
                        discussionCount: 1250,
                        fourLastDiscussions: []
                      }
                    },
                    status: 200,
                    statusText: 'OK',
                    headers: {},
                    config: config
                  });
                }
              });
            }
            
            // Par défaut, retourner une réponse générique de succès
            resolve({
              ...config,
              adapter: () => {
                return Promise.resolve({
                  data: { success: true },
                  status: 200,
                  statusText: 'OK',
                  headers: {},
                  config: config
                });
              }
            });
          }, 500);
        });
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
}

const app = createApp(App)

// Configuration pour éviter les problèmes d'hydratation
app.config.compilerOptions.whitespace = 'preserve'
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err)
  console.info('Error Info:', info)
}

app.use(router)

app.mount('#app')
